import axiosInstance from "../../../../Axios/axios";

const getCustomerReceivedFileTypeDropdown = async () => {
  const getCustomerReceivedFileTypeDropdown_URL = "Dashboard/GetCustomerReceivedFileTypeDropdown";
  return await axiosInstance.get(getCustomerReceivedFileTypeDropdown_URL);
};
export {getCustomerReceivedFileTypeDropdown}